import React, { FC } from "react";

const RequiredField: FC = () => {
  return <span className="required-asterisk">*</span>;
};

export default RequiredField;